import { currentEnvironment } from '@www/utils/environment';

export const USER_FEATURE_FLAGS = {
  VIDEO_ROOMS: 'VIDEO_ROOMS',
  ROOM_WITH_PASSWORDS: 'ROOM_WITH_PASSWORDS',
  ROOM_RECORDINGS: 'ROOM_RECORDINGS',
  ROOM_CUSTOM_NAMES: 'ROOM_CUSTOM_NAMES',
  BETA_FEATURES: 'BETA_FEATURES',
};

const INTERNAL_FLAGS_OBJECT = {
  ENABLE_VIDEO: {
    // true to enable video, false to disable video
    production: true,
    next: true,
    staging: true,
    development: true,
  },
  ENABLE_LOG: {
    // enables consoleLog to appear
    production: false,
    next: false,
    staging: false,
    development: true,
  },
  SEND_ROOM_LOG: {
    // enables createRoomLog to send to DynamoDB databas
    production: true,
    next: true,
    staging: true,
    development: false,
  },
  PARTICIPANT_FALSE_HOST_TRUE: {
    // set undefined if you don't want to override
    production: undefined,
    next: undefined,
    staging: undefined,
    development: undefined,
  },

  DAILY_AUDIO_ANALYSER: {
    // true to use AudioAnalyser, false to hide
    production: false,
    next: false,
    staging: true,
    development: true,
  },
  EXPERIMENTAL_FLAG: {
    // true to enable, false to hide
    production: false,
    next: false,
    staging: true,
    development: true,
  },
};

interface IInternalFlags {
  ENABLE_VIDEO?: boolean;
  PARTICIPANT_FALSE_HOST_TRUE?: boolean;

  DAILY_AUDIO_ANALYSER?: boolean;
  EXPERIMENTAL_FLAG?: boolean;
  ENABLE_LOG?: boolean;
  SEND_ROOM_LOG?: boolean;
}

const internalFlagsMap = (): IInternalFlags => {
  const internalFlagsMapped = {};
  Object.keys(INTERNAL_FLAGS_OBJECT).forEach((key) => {
    internalFlagsMapped[key] = INTERNAL_FLAGS_OBJECT[key][currentEnvironment()];
  });

  return internalFlagsMapped;
};

export const INTERNAL_FLAGS = internalFlagsMap();
